import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';
import MaskedInput from 'react-input-mask';

const MaskInputEinNumber = ({
  field, value, label, error, onChange,
}) => (
  <span>
    <MaskedInput className="form-control validate" mask="99 9999999" name={field} autoComplete="-" value={value} onChange={onChange} />

    {/* <MaskedInput
      mask="11 1111111"
      placeholder={label}
      className="form-control validate"
      name={field}
      size="10"
      value={value}
      onChange={onChange}
      autoComplete="off"
    /> */}
    <label className="active" htmlFor={label}>{label}</label>
    {error && <span className="help-block invalid ">{error}</span>}
  </span>
);

MaskInputEinNumber.propTypes = {
  field: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
};


export default MaskInputEinNumber;
